import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import placeholderAvatar from 'assets/images/user_placeholder.png'
import { someTimeAgo } from 'lib/dayjs'

import styles from './mediaItemProfile.module.scss'

interface Props {
    username: string
    avatarUrl?: string
    display_name: string
    createdAt: string | Date
}


export const MediaItemProfile = ({
    username,
    avatarUrl,
    display_name,
    createdAt
}: Props) => {
    const { t } = useTranslation()

    return (
        <div className={styles.profile}>
            <div className={styles.left}>
                <div className={styles.avatar}>
                    <Link to={`/${username}`}>
                        <img src={avatarUrl || placeholderAvatar} alt={t('avatar')} />
                    </Link>
                </div>
                <div className={styles.name}>
                    <Link to={`/${username}`}>{display_name}</Link>
                </div>
            </div>
            <div className={styles.time}>{someTimeAgo(createdAt)}</div>
        </div>
    )
}
